// src/firebase.js
import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  addDoc, 
  serverTimestamp 
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, logEvent } from 'firebase/analytics';

// 🧩 Configuración principal
const firebaseConfig = {
  apiKey: "AIzaSyALaWi18znN53EaE1Mfg0tg7VPAX1wtxH8",
  authDomain: "prventanas.firebaseapp.com",
  projectId: "prventanas",
  storageBucket: "prventanas.firebasestorage.app",
  messagingSenderId: "883440002332",
  appId: "1:883440002332:web:95a8a3b22fc124d7da06d9",
  measurementId: "G-YPQ4ZJE9MF"
};

// 🚀 Inicializar Firebase
const app = initializeApp(firebaseConfig);

// 🔥 Inicializar servicios
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// 📊 Habilitar Analytics (solo en navegador)
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// ✅ Exportar módulos
export { 
  app, 
  db, 
  storage, 
  functions, 
  analytics, 
  logEvent, 
  collection, 
  addDoc, 
  serverTimestamp 
};
